type ReadingTextProps = {
  parts: string[];
  activeIndex: number;
  onWordClick: (index: number) => void;
};

export function ReadingText({ parts, activeIndex, onWordClick }: ReadingTextProps) {
  let wordIndex = -1;

  return (
    <p className="reading-text" aria-label="טקסט לקריאה">
      {parts.map((part, index) => {
        if (/^\s+$/.test(part)) return part;
        wordIndex += 1;
        const currentIndex = wordIndex;
        return (
          <span
            className={currentIndex === activeIndex ? "word word--active" : "word"}
            key={`${index}-${part}`}
            onClick={() => onWordClick(currentIndex)}
          >
            {part}
          </span>
        );
      })}
    </p>
  );
}

